import { Button, Drawer, Radio, Space, Menu } from 'antd';
import {
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    UploadOutlined,
    UserOutlined,
    FileTextOutlined,
    ProductOutlined,
    GiftOutlined,
    HeartOutlined,
    GatewayOutlined,
    AuditOutlined,
    SettingOutlined,
    TagOutlined,
    GroupOutlined
} from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import { useApp } from "contexts/app";

const AppMenu = () => {
    const { showMenu, setShowMenu } = useApp()
    const navigate = useNavigate();
    const menuClick = (e) => {
        setShowMenu(false)
        navigate(e.key);
    }
    return (
        <Drawer
            title="Thuỷ Tiên Food"
            closable={{ 'aria-label': 'Close Button' }}
            onClose={e => setShowMenu(false)}
            open={showMenu}
        >

            <Menu
                style={{ width: 250, borderRightWidth: 0 }}
                mode="inline"
                onClick={menuClick}
                defaultSelectedKeys={['']}
                items={[
                    {
                        key: '/products',
                        icon: <ProductOutlined />,
                        label: 'Sản phẩm',
                        path: "acb"
                    },
                    {
                        key: '/orders',
                        icon: <FileTextOutlined />,
                        label: 'Đơn hàng',
                    },
                    // {
                    //   key: '/payment-confirm',
                    //   icon: <FileTextOutlined />,
                    //   label: 'Thanh toán',
                    // },
                    {
                        key: '/customers',
                        icon: <HeartOutlined />,
                        label: 'Khách hàng',
                    },

                    {
                        key: '/debt',
                        icon: <AuditOutlined />,
                        label: 'Công nợ',
                    },
                    {
                        key: '/vouchers',
                        icon: <GiftOutlined />,
                        label: 'Mã giảm giá',
                    },

                    {
                        key: '/setting',
                        icon: <SettingOutlined />,
                        label: 'Cài đặt',
                        children: [
                            {
                                key: '/product_option',
                                icon: <GatewayOutlined />,
                                label: 'Biến thể',
                            },
                            {
                                key: '/product_tag',
                                icon: <TagOutlined />,
                                label: 'Thẻ',
                            },
                            {
                                key: '/product_category',
                                icon: <GroupOutlined />,
                                label: 'Phân loại',
                            },
                        ]

                    },



                ]}
            />

        </Drawer>


    )
}
const Link = (props) => {
    return (


        <a href={props.href}>{props.children} </a>
    )
}

export default AppMenu;